;(function ($, undefined){

    var rnn = window.rnn;

    function start($link) {
        delete $link.data().resetText;
        $link
            .data('real-href', $link.attr('href'))
            .attr('href', '#')
            .button('loading');
    }

    function stop($link, keepText) {
        $link.attr('href', $link.data('real-href'))

        if (typeof keepText !== 'undefined' && keepText) {
            $link.removeClass('disabled').prop('disabled', false);
        }
        else {
            $link.button('reset');
        }
    }

    function createBar(message, type) {
        return $($.el.div({'class': 'loadingBar ' + type || ''},

            $.el.h3(message),
            $.el.div({'class': 'progress progress-striped progress-success active loading'},
                $.el.div({'class': 'bar', style:'width: 100%'})
            )
        ));
    }

    function removeBar(target){
        target.find('.loadingBar').remove();
    }

    rnn.modules.register('loading', {
        start: start,
        stop: stop,
        createBar: createBar,
        removeBar: removeBar
    });

})(jQuery);
